import { ComponentType } from 'react'
import { useAsync } from 'react-async'
import axios from 'axios'

type DiscoverablePlace = {
  code: string
  discoverable: boolean
}

export type CurrentVisitResponse = {
  location: {
    lat: number
    lng: number
    name: string
  }
  market?: { code: string } | null
  country?: DiscoverablePlace | null
  state?: DiscoverablePlace | null
}

const getCurrentVisit = () =>
  axios.get<CurrentVisitResponse | null>('current_visit')

export const useCurrentVisit = () => useAsync(getCurrentVisit)

export const useDeferredCurrentVisit = () =>
  useAsync({ deferFn: getCurrentVisit })

const withCurrentVisit =
  <P extends object>(Component: ComponentType<P>) =>
  (props: P) => {
    const { data: currentVisit, isLoading } = useCurrentVisit()

    return (
      <Component
        {...props}
        currentVisit={currentVisit?.data}
        currentVisitLoading={isLoading}
      />
    )
  }

export default withCurrentVisit
